import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { AlertTriangle, CheckCircle2, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-dark-DEFAULT" data-id="element-65">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-dark-100/20 via-dark-DEFAULT to-dark-DEFAULT z-0" data-id="element-66"></div>
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10 z-0" data-id="element-67"></div>

      <div className="relative z-10 max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center" data-id="element-68">
        {/* Left Column: Copy */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-left" data-id="element-69">
          {/* Warning Badge */}
          <div className="inline-flex items-center gap-2 bg-danger/10 border border-danger/30 px-4 py-2 rounded-sm mb-6" data-id="element-70">
            <AlertTriangle className="text-danger w-5 h-5" data-id="element-71" />
            <span className="text-danger font-bold uppercase tracking-wider text-sm" data-id="element-72">
              Warning: The Credit Bureaus Don't Want You To See This
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-heading font-bold leading-tight mb-6 text-white" data-id="element-73">
            STOP <span className="text-gold" data-id="element-74">DISPUTING</span>. <br data-id="element-75" />
            START <span className="text-danger" data-id="element-76">DELETING</span>.
          </h1>

          <p className="text-xl text-gray-300 mb-8 leading-relaxed max-w-lg" data-id="element-77">
            The "Credit Repair Sledgehammer" forces manual verification by
            bypassing the automated "e-OSCAR" system. Delete collections,
            inquiries, and late payments in as little as 30 days.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-78">
            <Button variant="primary" size="xl" className="group" onClick={() => document.getElementById('final-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-79">
              Get The Sledgehammer
              <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-80" />
            </Button>
            <div className="flex flex-col justify-center mt-2 sm:mt-0 sm:ml-4" data-id="element-81">
              <div className="flex items-center gap-2" data-id="element-82">
                <span className="line-through text-gray-600 text-sm" data-id="element-83">$27</span>
                <span className="text-white font-bold text-lg" data-id="element-84">
                  $6.39 Today
                </span>
              </div>
              <span className="text-danger text-xs font-bold uppercase tracking-wide" data-id="element-85">
                🔥 Launch Special — Limited Time
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3 text-sm text-gray-400" data-id="element-86">
            <div className="flex items-center gap-2" data-id="element-87">
              <CheckCircle2 className="text-success w-5 h-5" data-id="element-88" />
              <span data-id="element-89">100% Legal (Section 609 FCRA Compliant)</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-90">
              <CheckCircle2 className="text-success w-5 h-5" data-id="element-91" />
              <span data-id="element-92">Works for Collections, Charge-offs, & Inquiries</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-93">
              <CheckCircle2 className="text-success w-5 h-5" data-id="element-94" />
              <span data-id="element-95">Instant Digital Download</span>
            </div>
          </div>
        </motion.div>

        {/* Right Column: Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center" data-id="element-96">
          {/* Glow Effect */}
          <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full transform scale-75" data-id="element-97"></div>

          <img src="https://cdn.magicpatterns.com/uploads/ibfxiMXZPK16EfkAhYYNzD/producto1-1.png" alt="The Credit Repair Sledgehammer Digital Product" className="relative z-10 w-full max-w-md drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-98" />
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1,
      duration: 1,
      repeat: Infinity,
      repeatType: 'reverse'
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-gray-500" data-id="element-99">
        <div className="w-6 h-10 border-2 border-gray-600 rounded-full flex justify-center p-1" data-id="element-100">
          <div className="w-1 h-2 bg-gold rounded-full" data-id="element-101"></div>
        </div>
      </motion.div>
    </section>;
}